import { useTranslations } from "next-intl";
import { IDCard } from "../_icons/idCard";

interface AgeRestrictedProps {
  textClassName?: string;
  text?: string;
  color?: string;
  "data-testid"?: string;
}

export const AgeRestricted = ({
  textClassName,
  text,
  color,
  "data-testid": dataTestId,
}: AgeRestrictedProps) => {
  const t = useTranslations("AgeRestricted");
  return (
    <div className="flex gap-3 py-2" data-testid={dataTestId}>
      <div className="flex-shrink-0">
        <IDCard color={color} />
      </div>
      <p className={`font-weight-[400] text-[#000000] text-left ${textClassName}`}>
        {text || t("text")}
      </p>
    </div>
  );
};
